import { render, staticRenderFns } from "./LineupList.vue?vue&type=template&id=bfe10016&scoped=true"
import script from "./LineupList.vue?vue&type=script&lang=js"
export * from "./LineupList.vue?vue&type=script&lang=js"
import style0 from "./LineupList.vue?vue&type=style&index=0&id=bfe10016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe10016",
  null
  
)

export default component.exports